import { Box, Container, Paper, Stack, Typography } from "@mui/material";
import SectionReveal from "../components/SectionReveal";

const NAVY = "#102B63";
const SOFT_TEXT = "#4A5E84";
const CTA_ORANGE = "#F5A623";

const domainTexts = [
  "AXIONTEK est une société de Services Numériques spécialisée dans le conseil et l’accompagnement à la réalisation de projets de digitalisation dans différents secteurs d’activité.",
  "Dans cette démarche, la société met à la disposition des entreprises des compétences techniques portées par des experts dans leurs domaines.",
  "Son approche repose sur une vision claire de l’expertise attendue, construite à partir d’un diagnostic approfondi des besoins des différentes structures de l’entreprise, afin de proposer la solution digitale la plus optimale et la plus efficace, avec pour objectif d’améliorer durablement la performance de ses clients.",
  "Elle accompagne également le changement par la gestion des Hommes, grâce à une communication efficace, un accompagnement ciblé et une gestion agile des projets de transformation.",
  "Enfin, son expertise s’appuie sur des technologies déjà éprouvées et reconnues, garantissant ainsi la réussite et la viabilité des projets menés.",
];

function ContentCard({ title, children }) {
  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: { xs: 3.5, md: 4 },
        bgcolor: "rgba(255,255,255,0.98)",
        border: "1px solid rgba(16,43,99,0.08)",
        boxShadow: "0 14px 34px rgba(16,43,99,0.05)",
        overflow: "hidden",
      }}
    >
      <Box sx={{ p: { xs: 3, md: 3.6 } }}>
        <Box
          sx={{
            px: { xs: 0.4, md: 0.8 },
            pt: { xs: 0.4, md: 0.6 },
          }}
        >
          <Typography
            sx={{
              color: NAVY,
              fontWeight: 800,
              mb: 1.5,
              fontSize: { xs: "1rem", md: "1.08rem" },
            }}
          >
            {title}
          </Typography>

          {children}
        </Box>
      </Box>
    </Paper>
  );
}

export default function AproposPage() {
  return (
    <Box sx={{ pt: { xs: 4, md: 6 }, pb: { xs: 7, md: 9 } }}>
      <Container maxWidth="xl">
        <SectionReveal>
          <Paper
            sx={{
              p: { xs: 3.1, md: 5.1 },
              borderRadius: { xs: 4.5, md: 5 },
              background:
                "linear-gradient(135deg, #FFFFFF 0%, #F6F8FD 50%, #EEF3FB 100%)",
              border: "1px solid rgba(16,43,99,0.08)",
              boxShadow: "0 18px 45px rgba(16,43,99,0.08)",
              overflow: "hidden",
              position: "relative",
            }}
          >
            <Box
              sx={{
                position: "absolute",
                top: -60,
                right: -60,
                width: 180,
                height: 180,
                borderRadius: "50%",
                background:
                  "radial-gradient(circle, rgba(47,78,139,0.08), transparent 70%)",
                pointerEvents: "none",
              }}
            />

            <Box sx={{ position: "relative", zIndex: 1 }}>
              <Typography
                sx={{
                  color: CTA_ORANGE,
                  fontWeight: 800,
                  mb: 1,
                  textTransform: "uppercase",
                  letterSpacing: "0.08em",
                  fontSize: { xs: "0.78rem", md: "0.86rem" },
                }}
              >
                À propos
              </Typography>

              <Typography
                variant="h2"
                sx={{
                  color: NAVY,
                  mb: 2,
                  fontWeight: 800,
                  lineHeight: 1.08,
                  letterSpacing: "-0.03em",
                }}
              >
                Accélérer la performance de vos projets IT
              </Typography>

              <Typography
                sx={{
                  color: SOFT_TEXT,
                  lineHeight: 1.9,
                  maxWidth: 980,
                  mb: 2,
                  fontSize: { xs: "1rem", md: "1.04rem" },
                }}
              >
                Axiontek accompagne les entreprises dans la structuration,
                l’exécution et la réussite de leurs initiatives technologiques en
                mobilisant des expertises à forte valeur ajoutée, précisément
                alignées avec leurs enjeux.
              </Typography>

              <Typography
                sx={{
                  color: SOFT_TEXT,
                  lineHeight: 1.9,
                  maxWidth: 980,
                  mb: 4,
                  fontSize: { xs: "1rem", md: "1.04rem" },
                }}
              >
                Dans un contexte où les environnements IT deviennent toujours
                plus complexes, la réussite des projets repose sur la capacité à
                mobiliser les expertises adaptées, au moment où elles sont
                réellement nécessaires.
              </Typography>

              <Box sx={{ display: "grid", gap: 2.4 }}>
                <ContentCard title="Domaine d’intervention">
                  <Stack spacing={1.15}>
                    {domainTexts.map((text) => (
                      <Typography
                        key={text}
                        sx={{
                          color: SOFT_TEXT,
                          lineHeight: 1.9,
                          fontSize: { xs: "0.97rem", md: "1rem" },
                          maxWidth: "95%",
                          pr: { xs: 0.2, md: 0.6 },
                        }}
                      >
                        {text}
                      </Typography>
                    ))}
                  </Stack>
                </ContentCard>

                <ContentCard title="Mission">
                  <Typography
                    sx={{
                      color: SOFT_TEXT,
                      lineHeight: 1.9,
                      maxWidth: "95%",
                      fontSize: { xs: "0.97rem", md: "1rem" },
                      pr: { xs: 0.2, md: 0.6 },
                    }}
                  >
                    Intervenir par le conseil stratégique à la mise en œuvre
                    opérationnelle en passant par la conception des modèles
                    d’organisation et le plan d’action adopté à tous les niveaux
                    du process de transformation des informations analogiques en
                    informations numériques dans l’entreprise.
                  </Typography>
                </ContentCard>

                <Paper
                  elevation={0}
                  sx={{
                    borderRadius: { xs: 3.5, md: 4 },
                    background:
                      "linear-gradient(135deg, rgba(245,166,35,0.12) 0%, rgba(255,255,255,0.96) 100%)",
                    border: "1px solid rgba(16,43,99,0.08)",
                    textAlign: "center",
                    overflow: "hidden",
                  }}
                >
                  <Box sx={{ p: { xs: 3, md: 3.6 } }}>
                    <Typography
                      sx={{
                        color: CTA_ORANGE,
                        fontWeight: 800,
                        textTransform: "uppercase",
                        letterSpacing: "0.1em",
                        mb: 1,
                        fontSize: { xs: "0.76rem", md: "0.84rem" },
                      }}
                    >
                  
                    </Typography>

                    <Typography
                      sx={{
                        color: SOFT_TEXT,
                        lineHeight: 1.8,
                        mb: 1.1,
                        fontSize: { xs: "0.98rem", md: "1rem" },
                      }}
                    >
                     
                    </Typography>

                    <Typography
                      sx={{
                        color: NAVY,
                        fontWeight: 900,
                        letterSpacing: { xs: "0.08em", md: "0.14em" },
                        fontSize: { xs: "1.15rem", sm: "1.4rem", md: "1.7rem" },
                        lineHeight: 1.2,
                      }}
                    >
                      SCALE WITH CONFIDENCE
                    </Typography>
                  </Box>
                </Paper>
              </Box>
            </Box>
          </Paper>
        </SectionReveal>
      </Container>
    </Box>
  );
}